<template lang="pug">
  PrintablePanel
    PageHeader
      | Geo-Activity Report Results
      span.pl-2.ml-2.border-left.body-1
        router-link(:to="{name: 'geo_activity_search'}") Refine Search
    .mt-3.d-flex(v-if="!printable")
      .ml-auto
        router-link.btn.btn-primary(:to="{query: {print: true}}" target="_blank") Print

    Datatable.mt-3(:columns="columns"
      :sort-keys="sortKeys"
      :entries="results"
      sortable
      footer
      :per-page="6"
      :header-style="{fontSize: '12px'}"
      @sortTable="sortTable")
      tr.body-3(slot-scope="props")
        td
          router-link(:to="{path: `/person_summary/${props.entry.subjectSid}`}") View
        td {{ props.entry.lastName }}, {{ props.entry.firstName }}
        td {{ props.entry.birthDt }}
        td
          div {{ props.entry.idNbr }}
          div {{ props.entry.idTypeDesc }}
          div(v-if="props.entry.idStateCd") State: {{ props.entry.idStateCd }}
        td {{ props.entry.totalActivity }}
        td {{ props.entry.totalPurchases }}
        td {{ props.entry.totalBlocks }}
        td {{ props.entry.totalExceedances }}
        td {{ props.entry.totalReturns }}
        td {{ props.entry.totalQuantity }}
        td {{ props.entry.avgGramsPerBox || 'N/A' }}
</template>

<script>
import Datatable from '@/components/Datatable'
import PageHeader from '@/components/PageHeader'
import PrintablePanel from '@/components/PrintablePanel'
import { formItem } from '@/lib/formstore'
import axios from '@/lib/axios'
import { globalError } from '@/lib/utils'

export default {
  name: 'GeoActivityResults',
  data: function() {
    return {
      searchCriteria: formItem('geoactivity', 'searchCriteria'),
      results: [],
      columns: [
        'Person<br>Summary',
        'Name',
        'Date of Birth',
        'ID Number',
        'Total<br>Activities',
        'Purchases',
        'Blocks',
        'Exceedances',
        'Returns',
        'Total<br>Activity<br>Grams',
        'Average<br>grams/box',
      ],
      sortKeys: [
        false,
        false,
        false,
        false,
        'totalActivity',
        'totalPurchases',
        'totalBlocks',
        'totalExceedances',
        'totalReturns',
        'totalQuantity',
        'avgGramsPerBox',
      ],
    }
  },
  methods: {
    sortTable({ sortKey, sortDir }) {
      if (!sortKey) return this.results
      this.results.sort((a, b) => {
        let valueA = a[sortKey]
        let valueB = b[sortKey]
        if (sortKey === 'totalQuantity' || sortKey === 'avgGramsPerBox') {
          valueA = parseFloat(valueA)
          valueB = parseFloat(valueB)
        }
        return parseInt(valueA) < parseInt(valueB) ? -1 : 1
      })
      if (sortDir === 'desc') this.results.reverse()
    },
  },
  async beforeRouteEnter(to, _from, next) {
    try {
      let results = await axios().get('/api/reports/link', {
        params: { id: to.params.id },
      })
      next(vm => {
        vm.results = results.data.results
        if (vm.printable) vm.$nextTick(() => window.print())
      })
    } catch (err) {
      globalError(err)
    }
  },
  mounted() {
    scrollTo(0, 0)
  },
  components: {
    Datatable,
    PageHeader,
    PrintablePanel,
  },
}
</script>

<style lang="scss" scoped>
.border-left {
  border-left: 2px solid #e6e6e6;
}
</style>